module.exports = __webpack_public_path__ + "static/media/ic_auth_bank_fisdom.0cc38c12.svg";